import React from "react";
import { Pagination } from "react-admin";

const _Pagination = props => <Pagination rowsPerPageOptions={[5, 10, 25, 50]} {...props} />;

export default _Pagination;
